import React from "react";

const OrganizationSkeleton: React.FC = () => {
  return (
    <div className="space-y-6 py-6 px-6">
      {/* Page Header */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <div className="h-10 w-72 bg-slate-200 rounded-lg animate-pulse mb-2"></div>
        </div>
      </div>

      {/* Tabs Selector Bar */}
      <div className="flex flex-wrap items-center gap-3 !mt-2 !mb-5">
        <div className="bg-white border border-slate-200 rounded-full shadow-soft px-1.5 py-1.5 flex flex-wrap gap-1">
          <div className="h-9 w-32 bg-slate-200 rounded-full animate-pulse"></div>
          <div className="h-9 w-28 bg-slate-100/70 rounded-full animate-pulse"></div>
          <div className="h-9 w-36 bg-slate-100/70 rounded-full animate-pulse"></div>
        </div>
      </div>

      {/* Modern Split Grid Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
        
        {/* Left Column: Form Settings Skeleton */}
        <div className="lg:col-span-7 bg-white border border-slate-200 rounded-2xl shadow-soft p-6 md:p-8 space-y-8 animate-pulse">
          {/* Header info */}
          <div className="space-y-2">
            <div className="h-7 w-60 bg-slate-200 rounded"></div>
            <div className="h-4 w-full bg-slate-100 rounded"></div>
          </div>
          
          {/* Preset grid */}
          <div className="space-y-3">
            <div className="h-4 w-32 bg-slate-200 rounded"></div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              <div className="h-20 bg-slate-50 border border-slate-200 rounded-xl"></div>
              <div className="h-20 bg-slate-50 border border-slate-200 rounded-xl"></div>
              <div className="h-20 bg-slate-50 border border-slate-200 rounded-xl"></div>
            </div>
          </div>

          {/* Input sliders */}
          <div className="space-y-6">
            <div className="h-28 bg-slate-50 border border-slate-100 rounded-xl"></div>
            <div className="h-28 bg-slate-50 border border-slate-100 rounded-xl"></div>
          </div>

          {/* Action buttons */}
          <div className="flex items-center justify-end gap-3 pt-4 border-t border-slate-100">
            <div className="h-10 w-24 bg-slate-200 rounded-lg"></div>
            <div className="h-10 w-28 bg-slate-200 rounded-lg"></div>
          </div>
        </div>

        {/* Right Column: Gauge Visualizer Skeleton */}
        <div className="lg:col-span-5 space-y-6 animate-pulse">
          <div className="bg-white border border-slate-200 rounded-2xl shadow-soft p-6 flex flex-col items-center justify-center space-y-6">
            <div className="w-full text-left space-y-2">
              <div className="h-6 w-40 bg-slate-200 rounded"></div>
              <div className="h-4 w-64 bg-slate-100 rounded"></div>
            </div>
            
            {/* Circular Gauge mockup */}
            <div className="w-48 h-48 rounded-full border-4 border-slate-100 flex items-center justify-center">
              <div className="space-y-2 text-center">
                <div className="h-3 w-16 bg-slate-200 mx-auto rounded"></div>
                <div className="h-8 w-24 bg-slate-200 mx-auto rounded"></div>
                <div className="h-5 w-20 bg-slate-200 mx-auto rounded-full"></div>
              </div>
            </div>

            {/* Slider input track */}
            <div className="w-full space-y-2 px-2">
              <div className="h-4 w-full bg-slate-100/80 rounded"></div>
            </div>

            {/* Bottom tiles */}
            <div className="w-full grid grid-cols-3 gap-2">
              <div className="h-14 bg-slate-50 rounded-xl border border-slate-100"></div>
              <div className="h-14 bg-slate-50 rounded-xl border border-slate-100"></div>
              <div className="h-14 bg-slate-50 rounded-xl border border-slate-100"></div>
            </div>
          </div>

          {/* Info Card */}
          <div className="bg-slate-50 border border-slate-200 rounded-2xl p-5 h-24"></div>
        </div>
        
      </div>
    </div>
  );
};

export default OrganizationSkeleton;
